import React from 'react';
import { useDispatch } from 'react-redux';

const initialPage = {
  size: 10,
  totalElements: 0,
  totalPages: 0,
  number: 0,
};

/**
 * @template U, T
 * @typedef {{
 *  onChange: (params:U & { page : number; size : number }) => import('modules/global/generic.types').Action<T>;
 *  pagination: import('modules/global/generic.types').Page;
 *  requestParams: U;
 *  trigger?: Array<any>;
 * }} UsePagerProperties
 */

/**
 * @template U, T
 * @param {UsePagerProperties<U,T>} props
 */
const usePager = ({ onChange, pagination = initialPage, requestParams = {}, trigger = [] }) => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    // need isLoading ?
    dispatch(onChange({ ...requestParams, page: 0, size: pagination.size }));
  }, [...trigger]);

  /**
   * @param {number} page
   * @param {number} size
   */
  const onPageChange = (page, size) => {
    dispatch(onChange({ ...requestParams, page: page - 1, size }));
  };

  /**
   * @param {number} _
   * @param {number} size
   */
  const onSizeChange = (_, size) => {
    dispatch(onChange({ ...requestParams, page: 0, size }));
  };

  return {
    page: pagination.number + 1,
    size: pagination.size,
    totalElements: pagination.totalElements,
    onPageChange,
    onSizeChange,
  };
};

export default usePager;
